var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.01 19.3l-9.3-9.29 9.3-9.3-.71-.7-9.29 9.29L.71.01l-.7.7 9.29 9.3L.01 19.3l.7.71 9.3-9.3 9.29 9.3.71-.71z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KPHBvbHlnb24gcG9pbnRzPSIyMC4wMSAxOS4zIDEwLjcxIDEwLjAxIDIwLjAxIDAuNzEgMTkuMyAwLjAxIDEwLjAxIDkuMyAwLjcxIDAuMDEgMC4wMSAwLjcxIDkuMyAxMC4wMSAwLjAxIDE5LjMgMC43MSAyMC4wMSAxMC4wMSAxMC43MSAxOS4zIDIwLjAxIDIwLjAxIDE5LjMiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4=";
export { SvgX as ReactComponent };